import { createAsyncThunk } from '@reduxjs/toolkit';
import { accessCodeApi } from 'container/accessCodeApi';
import { STORE_NAME } from 'reduxStore/accessCode/initialState';
import { serializeError } from 'shared/utils/redux';

export const fetchUnsubscribedAccessCodes = createAsyncThunk(
  `${STORE_NAME}/fetchUnsubscribedAccessCodes`,
  async ({ distributionId }: { distributionId: string }) => {
    return accessCodeApi.unsubscribed(distributionId);
  },
  { serializeError },
);

export const searchAccessCodes = createAsyncThunk(
  `${STORE_NAME}/searchAccessCodes`,
  async ({ distributionId, query }: { distributionId: string; query: string }) => {
    return accessCodeApi.search(distributionId, query);
  },
  { serializeError },
);
